import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SpeciesToolsMenu from './components/SpeciesToolsMenu';

// Priority 24: after champis-help_rules' "Règles et aide" (26), before
// champis-users' "Membres" (23), then the private messages and flags (15).
export default function addSpeciesToolsMenu() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add('champisSpeciesToolsMenu', m(SpeciesToolsMenu, null), 24);
  });
}